module.exports = __webpack_public_path__ + "img/ofs-i-gongchengshi-shuzihua.bfe74e54.png";